<template>
  <div>
    <b-alert variant="success" :show="showAlert_success" @dismissed="showAlert_success = false">{{ alert_success_message
      }}</b-alert>

    <b-alert variant="danger" :show="showAlert_error" @dismissed="showAlert_error = false">{{ alert_error_message
      }}</b-alert>

    <b-container fluid>
      <h3 class="mt-3 mb-3">Inventory - Detailed View</h3>

      <div class="search_bar mb-3">
        <b-row v-if="this.$store.state.user_obj.account_type == 'admin'">
          <b-col cols="4" class="pr-1">
            <b-form-file v-model="upload_file" placeholder="Choose a file..."></b-form-file>
          </b-col>

          <b-col class="text-left p-0">
            <b-button class="btn-action" size="sm" variant="info" @click="onUploadFile">Upload</b-button>
          </b-col>
        </b-row>
      </div>

      <div class="search_bar mb-3">
        <b-row>
          <b-col cols="2" class="pr-1">
            <b-form-select size="sm" v-model="search_criteria.category_selected" :options="category_options" />
          </b-col>

          <b-col cols="2" class="pl-0 pr-1">
            <b-form-select size="sm" v-model="search_criteria.channel_selected" :options="channel_options" />
          </b-col>

          <b-col cols="2" class="pl-0 pr-1">
            <b-form-select size="sm" v-model="search_criteria.inventory_type_selected"
              :options="inventory_type_options" />
          </b-col>
          <b-col cols="3" class="pl-0 pr-1">
            <b-form-input id="input-small" size="sm" type="text" placeholder="Product SKU / Channel SKU / Other SKU"
              v-model="search_criteria.keyword" @keyup.enter="onSearch"></b-form-input>
          </b-col>
          <b-col class="text-left p-0">
            <b-button class="btn-action" size="sm" variant="info" @click="onSearch">
              <font-awesome-icon class="mr-1" icon="search" />Search
            </b-button>

            <b-button class="btn-action" size="sm" variant="info" @click="openScanner">Scan</b-button>

            <b-button
              v-if="checkPermission($store.state.user_obj, 'Warehouse Management', 'Inventory - Detailed View', 'Export CSV', true)"
              class="btn-action" size="sm" variant="info" @click="onExport">Export</b-button>
          </b-col>
        </b-row>
      </div>

      <div class="row m-1" v-if="scannerOn">
        <b-button block class="btn-action mb-1" size="md" variant="danger" @click="closeScanner()"
          v-if="scannerOn">Close</b-button>
        <StreamBarcodeReader style="width: 100%" @decode="onDecode" @loaded="onLoaded"></StreamBarcodeReader>
      </div>

      <div v-if="!grouped_items">

        <b-pagination size="sm" :total-rows="total_rows" v-model="currentPage" :per-page="TABLE_LIMIT"
          @change="onPageChange" :limit="PAGING_LIMIT"></b-pagination>

        <b-table responsive small outlined striped hover sticky-header="500px" :items="items" :fields="fields">
          <template v-slot:cell(qty)="data">
            <div style="text-align: center;">
              {{ displayQty(data.item.qty) }}
            </div>
          </template>

          <template v-slot:cell(expiration_date)="data">
            <div style="text-align: center;">
              {{ displayExpiryDate(data.item.expiration_date) }}
            </div>
          </template>

          <template v-slot:cell(stock_in_date)="data">
            <div style="text-align: center;">
              {{ displayDate(data.item.stock_in_date) }}
            </div>
          </template>

          <!-- <b-table responsive small outlined striped hover :items="items"> -->
          <template slot="status" slot-scope="data">{{
            data.item.status
            }}</template>

          <template slot="changes" slot-scope="data">
            <div style="max-width: 200px; white-space: pre-line; word-break: break-word;">
              {{ data.item.from_val }} ->{{ data.item.to_val }}
              <div v-if="data.item.other_reason">
                [{{ data.item.other_reason }}]
              </div>
              <div v-if="
                data.item.reschedule_date &&
                data.item.reschedule_date != '0000-00-00 00:00:00'
              ">
                [{{ data.item.reschedule_date }}]
              </div>
            </div>
          </template>

          <template slot="updated_at" slot-scope="data">
            <div v-if="data.item.updated_by != ''">
              {{ data.item.updated_at }}
            </div>
          </template>

          <template slot="action" slot-scope="data">
            <b-button class="btn-action" size="sm" variant="info" :to="{
              name: 'tracking_detail',
              params: { id: data.item.tracking_id }
            }" :disabled="!data.item.tracking_id">Detail</b-button>

            <b-button v-if="
              ($store.state.user_obj.account_type == 'admin' ||
                $store.state.user_obj.account_type == 'cs') &&
              data.item.status == 'pending'
            " class="btn-action" size="sm" variant="success" @click.stop="executeCR(data.item)">Execute</b-button>

            <b-button v-if="data.item.status == 'pending'" class="btn-action" size="sm" variant="danger"
              @click.stop="cancelCR(data.item)">Cancel</b-button>
          </template>

          <template v-slot:cell(action)="data">
            <b-button
              v-if="checkPermission($store.state.user_obj, 'Warehouse Management', 'Inventory - Detailed View', 'Transfer Location', ($store.state.user_obj.account_type == 'client_admin' || $store.state.user_obj.account_type == 'warehouse'))"
              class="btn-action" size="sm" variant="warning" :disabled="data.item.inventory_type == 'committed'"
              @click="openTransferModal(data.item)">Transfer</b-button>
          </template>
        </b-table>

        <b-pagination size="sm" :total-rows="total_rows" v-model="currentPage" :per-page="TABLE_LIMIT"
          @change="onPageChange" :limit="PAGING_LIMIT"></b-pagination>
      </div>

      <div v-if="grouped_items">

        <b-pagination size="sm" :total-rows="grouped_total_rows" v-model="currentPage" :per-page="TABLE_LIMIT"
          @change="onPageChange" :limit="PAGING_LIMIT"></b-pagination>

        <b-table responsive small outlined striped hover sticky-header="500px" :items="grouped_items" :fields="fields">
          <template v-slot:cell(qty)="data">
            <div style="text-align: center;">
              {{ displayQty(data.item.qty) }}
            </div>
          </template>

          <template v-slot:cell(expiration_date)="data">
            <div style="text-align: center;">
              {{ displayExpiryDate(data.item.expiration_date) }}
            </div>
          </template>

          <template v-slot:cell(stock_in_date)="data">
            <div style="text-align: center;">
              {{ displayDate(data.item.stock_in_date) }}
            </div>
          </template>

          <!-- <b-table responsive small outlined striped hover :items="items"> -->
          <template slot="status" slot-scope="data">{{
            data.item.status
          }}</template>

          <template slot="changes" slot-scope="data">
            <div style="max-width: 200px; white-space: pre-line; word-break: break-word;">
              {{ data.item.from_val }} ->{{ data.item.to_val }}
              <div v-if="data.item.other_reason">
                [{{ data.item.other_reason }}]
              </div>
              <div v-if="
                data.item.reschedule_date &&
                data.item.reschedule_date != '0000-00-00 00:00:00'
              ">
                [{{ data.item.reschedule_date }}]
              </div>
            </div>
          </template>

          <template slot="updated_at" slot-scope="data">
            <div v-if="data.item.updated_by != ''">
              {{ data.item.updated_at }}
            </div>
          </template>

          <template slot="action" slot-scope="data">
            <b-button class="btn-action" size="sm" variant="info" :to="{
              name: 'tracking_detail',
              params: { id: data.item.tracking_id }
            }" :disabled="!data.item.tracking_id">Detail</b-button>

            <b-button v-if="
              ($store.state.user_obj.account_type == 'admin' ||
                $store.state.user_obj.account_type == 'cs') &&
              data.item.status == 'pending'
            " class="btn-action" size="sm" variant="success" @click.stop="executeCR(data.item)">Execute</b-button>

            <b-button v-if="data.item.status == 'pending'" class="btn-action" size="sm" variant="danger"
              @click.stop="cancelCR(data.item)">Cancel</b-button>
          </template>

          <template v-slot:cell(action)="data">
            <b-button class="btn-action" size="sm" variant="info" @click="openDetailModal(data.item)">
              View Detail
            </b-button>
          </template>

        </b-table>

        <b-pagination size="sm" :total-rows="grouped_total_rows" v-model="currentPage" :per-page="TABLE_LIMIT"
          @change="onPageChange" :limit="PAGING_LIMIT"></b-pagination>
      </div>

      <b-modal id="detail-modal" ref="detailModal" title="Product Details" hide-footer size="xl" fullscreen>
        <!-- Product Summary -->
        <div class="product-summary p-3">
          <b-row>
            <b-col cols="6"><b>Product SKU:</b> {{ selectedProductSummary.product_sku }}</b-col>
            <b-col cols="6"><b>Channel:</b> {{ selectedProductSummary.channel }}</b-col>
          </b-row>
          <b-row>
            <b-col cols="6"><b>Lot Number:</b> {{ selectedProductSummary.vendor_lot_number }}</b-col>
            <b-col cols="6"><b>Stock-In Date:</b> {{ displayDate(selectedProductSummary.stock_in_date) }}</b-col>
          </b-row>
          <b-row>
            <b-col cols="6"><b>Location:</b> {{ selectedProductSummary.location }}</b-col>
            <b-col cols="6"><b>Inventory Type:</b> {{ selectedProductSummary.inventory_type }}</b-col>
          </b-row>
        </div>

        <hr />

        <!-- Client and Quantity Table -->
        <b-table responsive small outlined striped hover :items="selectedProductDetails" :fields="summaryFields">
          <template v-slot:cell(client)="detail">
            <div>{{ detail.item.client }}</div>
          </template>
          <template v-slot:cell(qty)="detail">
            <div>{{ displayQty(detail.item.qty) }}</div>
          </template>
        </b-table>

        <b-button variant="secondary" block @click="$refs.detailModal.hide()">Close</b-button>
      </b-modal>

      <b-modal id="modal-prevent-closing" ref="modal" title="Transfer Location" @show="resetTransferModal"
        @hidden="resetTransferModal" @ok="handleTransferOk">
        <div v-if="selectedTransferItem != null">
          <div class="row mb-2">
            <div class="col-6">
              <b>Channel</b>
            </div>
            <div class="col-6">
              {{ selectedTransferItem.channel }}
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-6">
              <b>Product SKU</b>
            </div>
            <div class="col-6">
              {{ selectedTransferItem.product_sku }}
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-6">
              <b>Channel SKU</b>
            </div>
            <div class="col-6">
              {{ selectedTransferItem.channel_sku }}
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-6">
              <b>Lot 1</b>
            </div>
            <div class="col-6">
              {{ selectedTransferItem.lot_1 }}
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-6">
              <b>Expiration Date</b>
            </div>
            <div class="col-6">
              {{ displayExpiryDate(selectedTransferItem.expiration_date) }}
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-6">
              <b>Stock-In Date</b>
            </div>
            <div class="col-6">
              {{ displayDate(selectedTransferItem.stock_in_date) }}
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-6">
              <b>Item Description</b>
            </div>
            <div class="col-6">
              {{ selectedTransferItem.product_description }}
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-6">
              <b>Inventory Type</b>
            </div>
            <div class="col-6">
              {{ selectedTransferItem.inventory_type }}
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-6">
              <b>Qty</b>
            </div>
            <div class="col-6">
              {{ displayQty(selectedTransferItem.quantity) }}
            </div>
          </div>
        </div>
        <hr />
        <form ref="form" @submit.stop.prevent="handleTransferSubmit">
          <b-form-group label="Quantity" label-for="quantity-input"
            :invalid-feedback="!transfer_obj.quantity ? 'Quantity is required' : transfer_obj.quantity <= 0 ? 'Quantity must be greater than 1' : ''"
            :state="transferState.quantityState">
            <b-form-input id="quantity-input" v-model="transfer_obj.quantity" :state="transferState.quantityState"
              required type="number" min="1"
              :max="selectedTransferItem ? selectedTransferItem.quantity : undefined"></b-form-input>
          </b-form-group>

          <b-form-group label="Inventory Type" label-for="inventoryType-input"
            :invalid-feedback="'Inventory Type is required'" :state="transferState.inventoryTypeState">
            <b-form-select id="inventoryType-input" v-model="transfer_obj.inventoryType"
              :state="transferState.inventoryTypeState" :options="transfer_inventory_type_options"
              required></b-form-select>
          </b-form-group>

          <b-form-group label="Location" label-for="location-input" :invalid-feedback="'Location is required'"
            :state="transferState.locationState">
            <b-form-input id="location-input" v-model="transfer_obj.location" :state="transferState.locationState"
              required></b-form-input>
          </b-form-group>

          <b-form-group label="Remark" label-for="remark-input" :invalid-feedback="'Remark is required'"
            :state="transferState.remarkState">
            <b-form-input id="remark-input" v-model="transfer_obj.remark"
              :state="transferState.remarkState"></b-form-input>
          </b-form-group>
        </form>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
import moment from "moment";
import VueBarcode from "vue-barcode";
import apiService from "../services/ApiService";
import { StreamBarcodeReader } from "vue-barcode-reader";

const fields = [
  // {
  //   key: "category",
  //   label: "Primary Category"
  // },
  {
    key: "channel",
    label: "Channel"
  },
  {
    key: "product_sku",
    label: "Product SKU"
  },
  {
    key: "channel_sku",
    label: "Channel SKU"
  },
  {
    key: "other_sku",
    label: "Other SKU"
  },
  {
    key: "lot_1",
    label: "Lot 1",
    class: "center_align"
  },
  {
    key: "expiration_date",
    label: "Expiration Date",
    class: "center_align"
  },
  {
    key: "stock_in_date",
    label: "Stock-In Date",
    class: "center_align"
  },
  {
    key: "product_description",
    label: "Item Description"
  },
  {
    key: "inventory_type",
    label: "Inventory Type",
    class: "txt_camelcase center_align"
  },
  {
    key: "quantity",
    label: "Qty",
    class: "center_align"
  },
  {
    key: "location",
    label: "Location",
    class: "center_align"
  },
  {
    key: "default_picking_location",
    label: "Picking Location",
    class: "center_align"
  },
  {
    key: "action",
    label: "Action"
  }
];

const fields_vendor2 = [
  // {
  //   key: "category",
  //   label: "Primary Category"
  // },
  {
    key: "channel",
    label: "Channel"
  },
  {
    key: "product_sku",
    label: "Product SKU"
  },
  {
    key: "channel_sku",
    label: "Channel SKU"
  },
  {
    key: "lot_1",
    label: "Lot 1",
    class: "center_align"
  },
  {
    key: "expiration_date",
    label: "Expiration Date",
    class: "center_align"
  },
  {
    key: "stock_in_date",
    label: "Stock-In Date",
    class: "center_align"
  },
  {
    key: "product_description",
    label: "Item Description"
  },
  {
    key: "inventory_type",
    label: "Inventory Type",
    class: "txt_camelcase center_align"
  },
  {
    key: "quantity",
    label: "Qty",
    class: "center_align"
  },
];

import global_function from "../mixins/global_function";

export default {
  name: "WMS_Products",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT", "NODEJS_API_URL"],
  mixins: [apiService, global_function],
  components: {
    barcode: VueBarcode,
    StreamBarcodeReader
  },
  data() {
    return {
      scannerOn: false,
      courier_options: [],
      export_date: {
        start_at: moment()
          .subtract(7, "d")
          .format("YYYY-MM-DD"),
        end_at: moment().format("YYYY-MM-DD")
      },
      upload_file: [],
      loader_full: false,
      loader: false,
      items: [],
      grouped_items: false,
      fields: null,
      currentPage: 1,
      table_offset: 0,
      total_rows: 0,
      grouped_total_rows: 0,
      updating_item: false,
      export_criteria: {
        courier_selected: null,
        status_selected: null
      },
      search_criteria: {
        keyword: "",
        status_selected: null,
        category_selected: null,
        inventory_type_selected: null,
        channel_selected: null
      },
      showAlert_success: false,
      alert_success_message: "",

      showAlert_error: false,
      alert_error_message: "",

      selectedTransferItem: null,
      transfer_obj: {
        quantity: null,
        inventoryType: null,
        location: null,
        remark: null,
      },
      transferState: {
        quantityState: null,
        inventoryTypeState: null,
        locationState: null,
        remarkState: null
      },

      channel_options: [
        {
          text: 'All Channel',
          value: null
        }
      ],

      category_options: [
        {
          value: null,
          text: "All Category"
        },
        {
          value: "active",
          text: "Active"
        },
        {
          value: "damaged",
          text: "Damaged"
        },
        {
          value: "hold",
          text: "Hold"
        },
        {
          value: "expired",
          text: "Expired"
        },
        {
          value: "committed",
          text: "Committed"
        },
        {
          value: "other",
          text: "Other"
        },
      ],

      inventory_type_options: [
        {
          value: null,
          text: "All Inventory Type"
        },
        {
          value: "active",
          text: "Active"
        },
        {
          value: "damaged",
          text: "Damaged"
        },
        {
          value: "hold",
          text: "Hold"
        },
        {
          value: "expired",
          text: "Expired"
        },
        {
          value: "committed",
          text: "Committed"
        },
        {
          value: "other",
          text: "Other"
        },
      ],

      transfer_inventory_type_options: [
        {
          value: "active",
          text: "Active"
        },
        {
          value: "damaged",
          text: "Damaged"
        },
        {
          value: "hold",
          text: "Hold"
        },
        {
          value: "expired",
          text: "Expired"
        },
        {
          value: "other",
          text: "Other"
        },
      ],

      status_options: [
        {
          value: null,
          text: "All Status"
        },
        {
          value: "Fulfilled",
          text: "Fulfilled"
        },
        {
          value: "Failed",
          text: "Failed"
        }
      ],
      selectedProductDetails: [],
      selectedProductSummary: false,
      summaryFields: false,
      detailedFields: [
        { key: "client", label: "Client" },
        { key: "product_sku", label: "Product SKU" },
        { key: "channel_sku", label: "Channel SKU" },
        { key: "qty", label: "Qty" },
        { key: "expiration_date", label: "Expiration Date" },
        { key: "stock_in_date", label: "Stock-In Date" }
      ]
    };
  },
  async created() {
    await this.getWMS_Products();
    await this.getCategorys();
    let channels_response = await this.getChannels(this.$store.state.user_obj);
    for (let i in channels_response.channels) {
      this.channel_options.push({
        value: channels_response.channels[i].name,
        text: channels_response.channels[i].name
      });
    }

    if (this.$store.state.user_obj.name == 'aml_comvita' || this.$store.state.user_obj.name == 'aml_vendor_master_' || this.$store.state.user_obj.account_type == 'vendor_2') {

      this.fields = fields_vendor2;
    } else {
      this.fields = fields;
    }

    this.initialized = true;
  },
  mounted() {
    this.loader = this.$loading.show({
      isFullPage: true,
      canCancel: false
    });
  },
  methods: {
    async onDecode(content) {
      this.alert_config = {
        show: true,
        variant: "danger",
        message: content,
      };

      if (this.scannerOn && !this.camera_cooldown) {
        this.result = content;
        this.search_criteria.keyword = content;
        this.getWMS_Products();
        this.closeScanner();
      }
    },
    onLoaded() {
      console.log("loaded barcode reader");
    },

    exportCSV() {
      let export_url = process.env.VUE_APP_API_HOST + "/export_products.php?";
      // export_url += "&tracking_number=" + this.search_criteria.tracking_number;
      export_url = encodeURI(export_url);
      window.open(export_url, "_blank");
    },

    number_formatter: value => {
      if (!value) {
        return '-';
      }
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    displayQty(qty) {
      if (qty == 0 || qty == "") {
        return "-";
      } else {
        return this.number_formatter(qty);
      }
    },

    displayDate(d) {
      if (d) {
        if (moment(d).format("YYYY-MM-DD") == 'Invalid date') {
          return '-';
        } else {
          return moment(d).format("YYYY-MM-DD");
        }
      } else {
        return "/";
      }
    },

    displayExpiryDate(d) {
      if (d) {
        if (moment(d).isBefore('2020', 'year')) {
          return '-'
        }
      }

      return this.displayDate(d);
    },

    async getWMS_Products() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "wms_product_get.php",
        data: {
          offset: this.table_offset,
          limit: this.TABLE_LIMIT,
          search_criteria: this.search_criteria,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        }
      });
      this.items = response.data.products;
      this.total_rows = parseInt(response.data.total_rows);
      this.grouped_items = response.data.grouped_products;
      this.grouped_total_rows = parseInt(response.data.grouped_total_rows);
      this.loader.hide();
    },

    async getCategorys() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "wms_category_option_get.php",
        data: {
        }
      });
      // this.yl_users = response.data.users;
      this.category_options = [
        {
          value: null,
          text: "All Categorys"
        }
      ];
      for (let i in response.data.categorys) {
        let tmp_category = response.data.categorys[i];
        this.category_options.push({
          value: tmp_category,
          text: tmp_category
        });
      }
      this.loader.hide();
    },

    onSearch() {
      for (const key in this.search_criteria) {
        if (typeof this.search_criteria[key] === "string") {
          this.search_criteria[key] = this.search_criteria[key].trim();
        }
      }
      this.getWMS_Products();
    },

    onPageChange(page_to_change) {
      this.table_offset = (page_to_change - 1) * this.TABLE_LIMIT;
      this.getWMS_Products();
    },

    async onUploadFile() {
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });

      let formData = new FormData();
      formData.append("excel_file", this.upload_file);

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "wms_inventory_import.php",
        headers: {
          "Content-Type": "multipart/form-data"
        },
        data: formData
      });

      if (response) {
        this.loader_full.hide();
        // alert("Upload success");
        // window.location.reload();
      }
    },

    onExport() {

      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });

      this.$http({
        url:
          this.NODEJS_API_URL + "/gen_excel",
        method: "POST",
        data: {
          "export_type": "location_view",
          limit: 999999,
          search_criteria: this.search_criteria,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        },
        responseType: "blob" // important
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "location_view.xlsx");
        document.body.appendChild(link);
        link.click();

        this.loader.hide();
      });
    },

    checkTransferFormValidity() {
      const valid = this.$refs.form.checkValidity()
      this.transferState.quantityState = this.$refs.form.querySelector('#quantity-input').checkValidity();
      this.transferState.inventoryTypeState = this.$refs.form.querySelector('#inventoryType-input').checkValidity();
      this.transferState.locationState = this.$refs.form.querySelector('#location-input').checkValidity();

      return valid
    },

    openTransferModal(item) {
      this.$bvModal.show('modal-prevent-closing')
      this.selectedTransferItem = item;
      this.transfer_obj = {
        quantity: item.quantity,
        inventoryType: item.inventory_type,
        location: item.location,
        remark: null,
      }
    },

    resetTransferModal() {
      this.transfer_obj = {
        quantity: null,
        inventoryType: null,
        location: null,
        remark: null,
      }

      this.transferState = {
        quantityState: null,
        inventoryTypeState: null,
        locationState: null,
        remarkState: null,
      }
    },

    async handleTransferOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      await this.handleTransferSubmit();
    },

    async handleTransferSubmit() {
      if (!this.checkTransferFormValidity()) {
        return
      }

      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "wms_inventory_transfer.php",
        data: {
          transfer_obj: this.transfer_obj,
          product_obj: this.selectedTransferItem,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        }
      });

      this.loader.hide();
      this.loader_full.hide();
      this.$nextTick(() => {
        this.$bvModal.hide('modal-prevent-closing')
      })

      if (response.data.status == "success") {
        this.showAlert_success = true;
        this.alert_success_message = 'Product is transferred Successfully';
        this.showAlert_error = false;
      } else {
        this.showAlert_error = true;
        this.alert_error_message = response.data.message;
        this.showAlert_success = false;
      }

      this.getWMS_Products();
    },

    openScanner() {
      this.scannerOn = true;
    },
    closeScanner() {
      this.scannerOn = false;
    },
    openDetailModal(item) {
      this.selectedProductSummary = { ...item }; // Store the selected product's summary
      this.selectedProductDetails = this.getFullProductDetails(item);
      this.$refs.detailModal.show();
    },

    getFullProductDetails(groupedItem) {
      // Group by client and sum quantities
      const groupedDetails = {};

      this.items.forEach(item => {
        if (
          item.product_sku === groupedItem.product_sku &&
          item.vendor_lot_number === groupedItem.vendor_lot_number &&
          item.stock_in_date === groupedItem.stock_in_date &&
          item.location === groupedItem.location &&
          item.inventory_type === groupedItem.inventory_type
        ) {
          if (!groupedDetails[item.client]) {
            groupedDetails[item.client_id] = { client: item.client, qty: 0 };
          }
          groupedDetails[item.client_id].qty += parseInt(item.quantity);
        }
      });

      return Object.values(groupedDetails);
    }

  }
};
</script>

<style>
th,
td {
  white-space: nowrap;
}

.center_align {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/WMS_Products.vue